import {Component, AfterViewInit, EventEmitter, Input, OnDestroy, Output, ViewChild, ElementRef, NgZone} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css'],
})
export class LocationComponent implements AfterViewInit, OnDestroy {
  @Input() validationToken = '';
  @Output() saved = new EventEmitter<void>();
  @ViewChild('addressInput') addressInput!: ElementRef<HTMLInputElement>;

  form = new FormGroup({
    address: new FormControl('', [Validators.required]),
    unit: new FormControl(''),
  });

  loading = false;
  errorMessage = '';

  private selectedLocation: any = null;
  private destroy$ = new Subject<void>();
  private autocomplete: google.maps.places.Autocomplete | null = null;

  constructor(
    private onboardingService: WebOnboardingService,
    private ngZone: NgZone,
  ) {}

  ngAfterViewInit(): void {
    this.initAutocomplete();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initAutocomplete(): void {
    if (typeof google === 'undefined' || !google.maps) {
      return;
    }

    this.autocomplete = new google.maps.places.Autocomplete(
      this.addressInput.nativeElement,
      {
        componentRestrictions: {country: 'ar'},
        types: ['address'],
      },
    );

    this.autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = this.autocomplete!.getPlace();
        if (place.geometry) {
          this.selectedLocation = {
            formattedAddress: place.formatted_address,
            lat: place.geometry.location?.lat(),
            lng: place.geometry.location?.lng(),
            placeId: place.place_id,
          };
          this.form.patchValue({address: place.formatted_address || ''});
        }
      });
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (!this.selectedLocation) {
      this.errorMessage = 'Seleccione una dirección del listado de sugerencias.';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const data = {
      token: this.validationToken,
      location: this.selectedLocation,
      unit: this.form.value.unit || undefined,
    };

    this.onboardingService
      .saveAddress(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading = false;
          this.saved.emit();
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al guardar la dirección. Intentá nuevamente.';
          }
        },
      });
  }
}
